import { createSlice } from '@reduxjs/toolkit';
import { TransportPackageTypesListStateType } from 'src/types/transportPackageType';

const initialState: TransportPackageTypesListStateType = {
    data: null,
    loading: false,
    error: false,
};

export const transportPackageTypesListSlice = createSlice({
    name: 'transportPackageTypesList',
    initialState,
    reducers: {
        getTransportPackageTypesListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getTransportPackageTypesListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getTransportPackageTypesListFetchFailure: (state) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        syncTransportPackageTypesFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        syncTransportPackageTypesFetchSuccess: (state, _action) => {
            state.loading = false;
        },
        syncTransportPackageTypesFetchFailure: (state) => {
            state.loading = false;
            state.error = true;
        },
        syncCatalogueTransportPackageTypesFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        syncCatalogueTransportPackageTypesFetchSuccess: (state, _action) => {
            state.loading = false;
        },
        syncCatalogueTransportPackageTypesFetchFailure: (state) => {
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getTransportPackageTypesListFetch,
    getTransportPackageTypesListFetchSuccess,
    getTransportPackageTypesListFetchFailure,
    syncTransportPackageTypesFetch,
    syncTransportPackageTypesFetchSuccess,
    syncTransportPackageTypesFetchFailure,
    syncCatalogueTransportPackageTypesFetch,
    syncCatalogueTransportPackageTypesFetchSuccess,
    syncCatalogueTransportPackageTypesFetchFailure,
} = transportPackageTypesListSlice.actions;

export default transportPackageTypesListSlice.reducer;
